import { render, staticRenderFns } from "./formHeader.vue?vue&type=template&id=376170e4"
import script from "./formHeader.vue?vue&type=script&lang=js"
export * from "./formHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports